// src/App.js - Updated with TSO authentication integration
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import CyberGame from './CyberGame';
import LeaderboardPage from './pages/LeaderboardPage.tsx';
import LoginPage from './pages/LoginPage.tsx';
import RegisterPage from './pages/RegisterPage.tsx';
import { AuthProvider } from './context/AuthContext.tsx';
import { GameProvider } from './context/GameContext.js';
import TSOAuthDetector from './components/TSOAuthDetector.tsx';
import { supabase } from './lib/supabase';
import SimpleAudioManager from './utils/SimpleAudioManager';

function App() {
  // Handle audio autoplay restrictions by listening for user interaction
  useEffect(() => {
    const handleUserInteraction = () => {
      // Check user's audio preference
      const audioEnabled = localStorage.getItem('audio_enabled') !== 'false';
      
      if (audioEnabled) {
        // Try resuming any paused audio (to handle browser autoplay restrictions)
        const bgm = SimpleAudioManager.getAudio('bgm');
        if (bgm && bgm.paused) {
          bgm.play().catch(e => console.log('Failed to play background music', e));
        }
        
        const typing = SimpleAudioManager.getAudio('typing');
        if (typing && typing.paused) {
          typing.play().catch(e => console.log('Failed to play typing sound', e));
        }
      }
      
      // Remove event listeners after first interaction
      document.removeEventListener('click', handleUserInteraction);
      document.removeEventListener('keydown', handleUserInteraction);
    };
    
    // Add event listeners for first user interaction
    document.addEventListener('click', handleUserInteraction);
    document.addEventListener('keydown', handleUserInteraction);
    
    // Clean up event listeners when component unmounts
    return () => {
      document.removeEventListener('click', handleUserInteraction);
      document.removeEventListener('keydown', handleUserInteraction);
    };
  }, []);
  
  return (
    <AuthProvider>
      <GameProvider>
        <Router>
          <TSOAuthDetector />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/game" element={<CyberGame />} />
            <Route path="/leaderboard" element={<LeaderboardPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
          </Routes>
        </Router>
      </GameProvider>
    </AuthProvider>
  );
}

export default App;